import React, {useEffect, useState} from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import s from './CastomerOrders.module.css';
import AddFilterButton from '../../Components/Buttons/AddFilterButton';
import CustomerOrdersFilter from '../../Components/Filter/CustomerOrdersFilter';
import styleTableGrid from '../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import style from '../PaperworkList/PaperworkList.module.css';
import CustomerOrdersRowElement from './CustomerOrdersRowElement';
import {useTranslation} from 'react-i18next';
import {validationFilterForm} from '../../assets/utils/validation';
import {Form, Formik} from 'formik';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import {
	LogisticListRequestType,
	OrderInDepotLogisticType,
} from '../../types/TypesDepotLogistic';

import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';

import ShoppingTotal from '../../Components/ShoppingTotal/ShoppingTotal';
import SearchInputFurfur from '../../Components/Filter/Components/SearchInputFurfur';
import {submitFilterFieldCleaner} from '../../assets/utils/utils';
import {useGetLogisticListQuery} from '../../redux/DepotSlice/depotLogisticApi';
import useClickMoreButton from '../../hooks/useClickMoreButton';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const CustomerOrders = () => {
	const {t} = useTranslation();
	const [allOrders, setAllOrders] = useState<OrderInDepotLogisticType[]>([]);
	const [filters, setFilters] = useState<any>({
		filter_active: false,
		offset: 0,
	});

	const {handleClickMoreButton} = useClickMoreButton(setFilters);
	const [filterMenu, setFilterMenu] = useState(false);
	const restrictions = useStatusRestriction();
	const {data, isLoading, error} = useGetLogisticListQuery(filters, {
		skip: !restrictions.canAccessWarehouseSection,
	});
	const columnsTableCustomerOrders = [
		'',
		'',
		'ID',
		'дата',
		"ім'я замовника",
		'вартість',
		'Статус доставки',
		'Дії',
	];
	const infoElementsRow = [
		{
			color: 'colorGreen',
			text: t('Обслуговувати якнайшвидше'),
		},
		{
			color: 'colorYellow',
			text: t('пріоритет нижче, треба мати на увазі'),
		},
		{
			color: 'colorGrey',
			text: t('цікавить в останню чергу'),
		},
	];
	const initialListFormValues: LogisticListRequestType = {
		searchtext: '',
		status_pay: '',
		delivery_type: '',
		payment_method: '',
		status_delivery: '',
		offset: 0,
	};
	const handleSubmitListForm = (values: any) => {
		const filteredValues = submitFilterFieldCleaner(values);
		setAllOrders([]);
		setFilters({
			...filteredValues,
			filter_active: true,
			offset: 0, // сбрасываем пагинацию при новом фильтре
		});
		setFilterMenu(false);
	};
	const handleSearchInputFurfur = (value: LogisticListRequestType) => {
		setAllOrders([]);
		setFilters({
			filter_active: true,
			...value,
			offset: Number(value.offset) || 0,
		});
	};
	const handleDeleteFromList = (deletedId: number) => {
		setAllOrders((prev) => prev.filter((item) => item.order_id !== deletedId));
	};
	useEffect(() => {
		if (!data?.orders?.length) return;
		setAllOrders((prev) => {
			const existingIds = new Set(prev.map((item) => item.order_id));
			const newUnique =
				data.orders?.filter((item: any) => !existingIds.has(item.order_id)) ??
				[];
			return [...prev, ...newUnique];
		});
	}, [data]);

	if (!restrictions.canAccessWarehouseSection) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Замовлення клієнтів')} />
			<Formik
				enableReinitialize
				validationSchema={validationFilterForm}
				initialValues={initialListFormValues}
				onSubmit={handleSubmitListForm}
			>
				{({handleSubmit}) => {
					return (
						<Form onSubmit={handleSubmit}>
							<div className={s.filterButton}>
								<AddFilterButton
									setFilterMenu={setFilterMenu}
									filterMenu={filterMenu}
									color={'blue'}
								/>
								<SearchInputFurfur
									fieldName={'searchtext'}
									callback={handleSearchInputFurfur}
								/>
							</div>
							{filterMenu && (
								<div>
									<CustomerOrdersFilter
										active={filterMenu}
										setFilters={setFilters}
									/>
								</div>
							)}
						</Form>
					);
				}}
			</Formik>
			<div className={s.infoRow}>
				{infoElementsRow?.map((item, index) => (
					<div className={s.infoRowItem} key={index + item.text}>
						<div className={`${s.colorCircle} ${s[item.color]}`} />
						<div className={s.infoRowItemText}>{item.text}</div>
					</div>
				))}
			</div>
			{isLoading ? (
				<div>
					<PreLoaderComponent type={'category'} size={'big'} />
				</div>
		) : allOrders ? (
			<div className={s.tableContainer}>
				{/* Обгортка для адаптивного горизонтального скролу */}
				<div className={s.tableWrapper}>
					<div className={styleTableGrid.tableGrid}>
						<GridTableHead 
							columns={columnsTableCustomerOrders}
							gridTemplateColumns="repeat(2, 1fr) repeat(2, 3fr) 5fr repeat(3, 4fr)"
							customClassName={styleTableGrid.tableRow}
						/>
						{allOrders.map((order: OrderInDepotLogisticType, index: number) => (
							<CustomerOrdersRowElement
								order={order}
								index={index}
								key={order.order_id}
								onDeleteSuccess={handleDeleteFromList}
							/>
						))}
						{allOrders.length >= 10 && (
							<div className={s.buttonWrapper}>
								<LightGreenButton
									type={'button'}
									text={`${t('дивитися') + ' ' + t('більше')}`}
									onClick={handleClickMoreButton}
								/>
							</div>
						)}
					</div>
				</div>
				<div className={s.totalWrapper}>
					<ShoppingTotal
						sumBonuses={data?.count}
						sumMoney={data?.sum_money ?? ''}
						points={data?.sum_points}
					/>
				</div>
			</div>
			) : (
				error &&
				'data' in error &&
				typeof error.data === 'object' && (
					<p style={{color: 'red'}}>
						{(error.data as any).message ?? 'Щось пішло не так'}
					</p>
				)
			)}
		</div>
	);
};

export default CustomerOrders;
